module.exports = __webpack_public_path__ + "static/banner-c28e7df8623425ebd76adbe3aed06b78.png";